import saltyCards from "./saltyCards.json";

export type SaltyCard = {
  name: string;
  // scryfall card id
  id: string;
  salt: number;
};

export type SaltySet = SaltyCard[];

const decode = (payload: string): string => {
  if (typeof window === "undefined") {
    return Buffer.from(payload, "base64").toString("utf-8");
  }
  // atob gives us a binary string, so decode it as utf-8 for cards with accents
  const binary = window.atob(payload);
  const bytes = Uint8Array.from(binary, (character) => character.charCodeAt(0));
  return new TextDecoder().decode(bytes);
};

let decoded: SaltySet[] | null = null;

// The card data is base64'd in saltyCards.json so the names aren't searchable
// in the browser source or network tab. Decoded once, then cached.
export const getSaltySets = (): SaltySet[] => {
  if (!decoded) {
    decoded = JSON.parse(decode(saltyCards.payload)) as SaltySet[];
  }
  return decoded;
};

export const getSaltySet = (index: number): SaltySet | undefined => getSaltySets()[index];
